import React from 'react'

import Table from '../../components/BPMTable/TableComponents/TableWrapper/SetupTableData'
import MyTeamCostCentersTableCreator from '../../tableDefinitions/MyTeam/MyTeamCostCentersTableCreator'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'

export default function CostCentersTable(props) {
    var tableCreatorCreator = tableCreatorCreatorFactoryCreator.getTableCreatorCreatorFromIdentifier(MyTeamCostCentersTableCreator.getId(), {tcFilters: props.filters})
    tableCreatorCreator.setParentProps(props)
    const tableCreator = tableCreatorCreator.getTableCreator('My Team Cost Centers')

    return (
        <Table
            TableCreator={tableCreator}
            stickyHeader
        />
    )
}
